import React from "react";

export const CloseBtn = ({ classes, ...rest }) => {
  return (
    <div className={classes} {...rest}>
      <i className="fa fa-times-circle" />
    </div>
  );
};
